import { render, staticRenderFns } from "./PrjQuota.vue?vue&type=template&id=02707848&scoped=true&"
import script from "./PrjQuota.vue?vue&type=script&lang=ts&"
export * from "./PrjQuota.vue?vue&type=script&lang=ts&"
import style0 from "./PrjQuota.vue?vue&type=style&index=0&id=02707848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02707848",
  null
  
)

export default component.exports